import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { StyleSheet, Text, View } from '@react-pdf/renderer';
const styles = StyleSheet.create({
    groupTitle: {
        fontSize: '24px',
        fontWeight: 'bold',
        borderBottom: '3px solid #D5D5D5',
        marginBottom: '20px',
        marginTop: '32px',
    },
    secondGroupContainer: {
        minHeight: '45px',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingLeft: '48px',
        paddingRight: '16px',
    },
    secondGroupTitle: {
        fontSize: '18px',
        fontWeight: 'bold',
    },
    secondGroupValue: {
        fontSize: '18px',
        fontWeight: 'bold',
    },
    thirdGroupContainer: {
        minHeight: '54px',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingLeft: '96px',
        paddingRight: '16px',
        borderBottom: '1px solid #D5D5D5',
    },
    thirdGroupTitle: {
        fontSize: '16px',
        fontWeight: 'bold',
    },
    thirdGroupValue: {
        fontSize: '16px',
        fontWeight: 'bold',
    },
    lastGroupContainer: {
        minHeight: '34px',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingLeft: '48px',
        paddingRight: '16px',
        marginLeft: '96px',
        borderBottom: '1px solid #D5D5D5',
    },
    lastGroupTitle: {
        width: '200px',
        fontSize: '16px',
    },
    lastGroupValue: {
        fontSize: '16px',
    },
});
const PriceBreakdown = ({ groups, language, getBreakdownGroupContentValue }) => {
    const processTitle = (text) => {
        if (text === null || text === void 0 ? void 0 : text.includes(';')) {
            const titleArr = text.split(';');
            return titleArr[0];
        }
        return text;
    };
    const processContent = (text, titleValue) => {
        if (titleValue === null || titleValue === void 0 ? void 0 : titleValue.includes(';')) {
            const contentArr = titleValue.split(';');
            return contentArr[1];
        }
        return text;
    };
    return (_jsx(View, { children: groups.map(group => {
            var _a;
            if (!group.title)
                return null;
            return (_jsxs(View, { children: [_jsx(Text, { style: styles.groupTitle, children: group.title }), (_a = group === null || group === void 0 ? void 0 : group.content) === null || _a === void 0 ? void 0 : _a.map(secondGroup => {
                        var _a, _b;
                        return (_jsxs(View, { children: [_jsxs(View, { style: [
                                        styles.secondGroupContainer,
                                        { backgroundColor: ((_a = secondGroup === null || secondGroup === void 0 ? void 0 : secondGroup.content) === null || _a === void 0 ? void 0 : _a.length) ? '#E7F7FF' : 'white' },
                                    ], children: [_jsx(Text, { style: styles.secondGroupTitle, children: processTitle(secondGroup.title) }), _jsx(Text, { style: styles.secondGroupValue, children: processContent(getBreakdownGroupContentValue(secondGroup === null || secondGroup === void 0 ? void 0 : secondGroup.value, (secondGroup === null || secondGroup === void 0 ? void 0 : secondGroup.unit) || '', language), secondGroup.title) })] }), (_b = secondGroup === null || secondGroup === void 0 ? void 0 : secondGroup.content) === null || _b === void 0 ? void 0 : _b.map(thirdGroup => {
                                    var _a;
                                    return (_jsxs(View, { children: [_jsxs(View, { style: styles.thirdGroupContainer, children: [_jsx(Text, { style: styles.thirdGroupTitle, children: thirdGroup.title }), _jsx(Text, { style: styles.thirdGroupValue, children: getBreakdownGroupContentValue((thirdGroup === null || thirdGroup === void 0 ? void 0 : thirdGroup.value) || 0, (thirdGroup === null || thirdGroup === void 0 ? void 0 : thirdGroup.unit) || '', language) })] }), (_a = thirdGroup === null || thirdGroup === void 0 ? void 0 : thirdGroup.content) === null || _a === void 0 ? void 0 : _a.map(lastGroup => (_jsx(View, { children: _jsxs(View, { style: styles.lastGroupContainer, children: [_jsx(Text, { style: styles.lastGroupTitle, children: lastGroup.title }), _jsx(Text, { style: styles.lastGroupValue, children: getBreakdownGroupContentValue((lastGroup === null || lastGroup === void 0 ? void 0 : lastGroup.value) || 0, (lastGroup === null || lastGroup === void 0 ? void 0 : lastGroup.unit) || '', language) })] }) }, lastGroup.title)))] }, thirdGroup.title));
                                })] }, secondGroup.title));
                    })] }, group.key));
        }) }));
};
export default PriceBreakdown;
